module.exports = __webpack_public_path__ + "img/logo-stone.aa169e0d.png";